export const skills = [
    {
        title: "Website Strategy",
        icon: "pin-angle-fill",
        yoe:
            "10+",
        example: "Strategic Planning, Website Development and Maintenance, Conversion Rate Optimization, SEO Strategy, Digital Marketing",
    },
    {
        title: "SEO/GEO",
        icon: "pin-angle-fill",
        yoe:
            "5+",
        example: "Technical SEO, AI-Driven Optimizations, Core Web Vitals, Accessibility, Page Speed, Mobile-Friendliness, Structured Data",
    },
    {
        title: "Front-End Web Development and UX/UI Design",
        icon: "pin-angle-fill",
        yoe:
            "10+",
        example: "HTML, CSS, Javascript, Ruby on Rails, Bootstrap, Wireframe and Prototyping",
    },
    {
        title: "Analytics",
        icon: "pin-angle-fill",
        yoe:
            "10+",
        example: "Google Analytics, Looker Studio, Event and Conversion Tracking, Google Tag Manager",
    }
]